import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { useWizardForm } from "./model";
import styles from "./styles.scss";

function WizardForm(props: Props) {
  const { t } = useTranslation();
  const {
    component,
    title,
    nextPlaceholder,
    previousPlaceholder,
    canMoveToNextStep,
    submitPlaceholder,
    currentStep,
    isFirstStep,
    isLastStep,
    incrementStep,
    decrementStep,
  } = useWizardForm(props);

  return (
    <div className={styles.wizardForm}>
      {props.steps.length > 1 ? (
        <h1 className={styles.title}>
          {t("wizardForm.title")} {currentStep + 1}
          {title && ` : ${title}`}
        </h1>
      ) : (
        title && <h1 className={styles.title}>{title}</h1>
      )}
      <div className={styles.main}>{component}</div>
      <div className={styles.navigation}>
        {!isFirstStep() && (
          <button className={styles.previousButton} onClick={decrementStep}>
            {previousPlaceholder}
          </button>
        )}
        {!isLastStep() && (
          <button
            className={styles.nextButton}
            disabled={!canMoveToNextStep}
            onClick={incrementStep}
          >
            {nextPlaceholder}
          </button>
        )}
        {isLastStep() && (
          <button className={styles.nextButton} onClick={props.submit}>
            {submitPlaceholder}
          </button>
        )}
      </div>
    </div>
  );
}

export { WizardForm };
